// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/auth/me',
    requestBody: null,
    response: '{"utente":{"ruolo":"string"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/lipe?societaId=&anno=&periodicita=',
    requestBody: null,
    response: '[{...lipe, allegati:[]}]'
  },
  {
    method: 'POST',
    endpoint: '/api/lipe',
    requestBody: 'FormData{societaId,anno,periodicita,periodo,ivaDebito?,ivaCredito?,importoVersato?,creditoRiportato?,dataPresentazione?,protocolloTelem?,commento?,files[]}',
    response: '{"success":true,"id":"number"}'
  },
  {
    method: 'GET',
    endpoint: '/api/lipe/:id/allegati/:allegatoId/download',
    requestBody: null,
    response: 'file binary'
  },
  {
    method: 'POST',
    endpoint: '/api/lipe/:id/allegati',
    requestBody: 'FormData{files[]}',
    response: '{"success":true,"ids":[...]}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/lipe/:id/allegati/:allegatoId',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/lipe/:id',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
